/*
* 半屏弹窗组件
* 用于满足需要半屏弹窗交互的场景
* 调用方式: new HalfScreenDialog(html, buttons)
* 后续规划：
* 1. 高层API封装：封装常见HalfScreenDialog场景函数，快速调用
* 2. 解决多个半屏弹窗组件同时存在时的冲突问题
*/

import wxBridge from '../jsbridge/jsbridge_login_queue.js';

function HalfScreenDialog(html = '', buttons, bottomHtml = '', ) {
    this.init(html, buttons, bottomHtml)

    wxBridge && wxBridge.invoke("setGameTab", {isShowTab: 0})
}

HalfScreenDialog.prototype.init = function (html, buttons, bottomHtml) {
    var self = this
    this.insertStyle()
    this.insertDom()
    this.insertData(html)
    if (!(Array.isArray(buttons) && buttons.length === 0)) {
        this.insertButton(buttons)
    }
    bottomHtml && this.insertBottom(bottomHtml);
    this.retainDialog = false;
    this.dialogDom = document.querySelector('.wg-basic-half-screen-dialog')
    this.maskDom = document.querySelector('.wg-basic-half-screen-dialog__mask')
    this.panelDom = document.querySelector('.wg-basic-half-screen-dialog__wraper')
    this.bottomDom = document.querySelector('.wg-basic-half-screen-dialog__bottom')
    setTimeout(function () {
        self.dialogDom.style.bottom = 0
        self.maskDom.style.opacity = 1
        self.panelDom.style.bottom = 0
    }, 50)

    this.bindEvent(buttons)
}

HalfScreenDialog.prototype.insertStyle = function () {
    var dialogDom = document.getElementById('wg-half-screen-common-dialog__style')
    if (!dialogDom) {
        var dom = document.createElement('style')
        dom.setAttribute('type', "text/css")
        dom.setAttribute('id', "wg-half-screen-common-dialog__style")

        const style = `
.wg_accessibility_mode .wg-basic-half-screen-dialog__button {
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
}
.wg-basic-half-screen-dialog {
	position: fixed;
	left: 0;
	bottom: -100%;
	width: 100%;
	height: 100%;
	z-index: 100001;
}

.wg-basic-half-screen-dialog__mask {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	background-color: rgba(0, 0, 0, 0.6);
	transition: opacity .1s linear
}

.wg-basic-half-screen-dialog__wraper {
	position: absolute;
	left: 0;
	bottom: -100%;
	width: 100%;
    min-height: 300px;
    max-height: 75%;
	background: #ffffff;
	border-top-left-radius: 12PX;
	border-top-right-radius: 12PX;
    transition: bottom .4s ease-in-out;
    color: rgba(0,0,0,0.9);
    display: flex;
    flex-direction: column;
}

.wg-basic-half-screen-dialog__wraper::-webkit-scrollbar {
    display: none;
}

.wg_dark_mode .wg-basic-half-screen-dialog__wraper {
    background: #232323;
    color: rgba(255,255,255,0.8);
}

.wg-basic-half-screen-dialog__content {
    flex-grow: 1;
    padding-top: 12px;
    overflow-y: scroll;
}

.wg-basic-half-screen-dialog__content::-webkit-scrollbar {
    display: none;
}

.wg-basic-half-screen-dialog__bottom {
	width: 100%;
	display: flex;
    padding-top: 32px;
    padding-bottom: 32px;
	justify-content: center;
    margin: 0 auto;
}

.wg-basic-half-screen-dialog__button {
	width: 5.5rem;
	height: 2rem;
    background: rgba(0, 0, 0, 0.05);
	color: #06ae56;
	border-radius: 4px;
	font-family: PingFangSC-Medium;
	font-size: 17PX;
	varter-spacing: 1px;
    text-align: center;
    line-height: 2rem;
    margin-right: 16px;
}

.wg-basic-half-screen-dialog__button:last-child {
    margin-right: 0;
} 

.wg_dark_mode .wg-basic-half-screen-dialog__button {
    background: rgba(255, 255, 255, 0.08);
	color: rgba(255, 255, 255, 0.8);
}

.wg-basic-half-screen-dialog__button-danger {
	background-color: #d9534f;
	color: #FFFFFF;
}

.wg_dark_mode .wg-basic-half-screen-dialog__button-danger {
	background-color: #d9534f;
	color: #FFFFFF;
}

.wg-basic-half-screen-dialog__button-single {
    width: 9rem;
}

.wg-basic-half-screen-dialog__button-primary {
	background: #07C160;
	color: #FFFFFF;
}
.wg_dark_mode .wg-basic-half-screen-dialog__button-primary {
	background: #07C160;
	color: #FFFFFF;
}
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .wg-basic-half-screen-dialog__wraper {
      padding-bottom: 34px;
  }
}
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .wg-basic-half-screen-dialog__wraper {
      padding-bottom: 31px;
  }
}
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .wg-basic-half-screen-dialog__wraper {
      padding-bottom: 31px;
  }
}
`

        dom.innerHTML = style
        var head = document.getElementsByTagName('head')[0]
        head.appendChild(dom)
    }
}

HalfScreenDialog.prototype.insertDom = function () {
    var dialogDom = document.getElementById('wg-basic-half-screen-dialog-dom')
    if (!dialogDom) {
        var dom = document.createElement('div')
        dom.setAttribute('id', "wg-basic-half-screen-dialog-dom")

        var isDarkMode = document.querySelector('.wg_dark_mode');
        dom.classList.add(`wg-basic-half-screen-dialog`)
        if (isDarkMode) {
            dom.classList.add(`wg_dark_mode`)
        }
        var div = [
            '<div class="wg-basic-half-screen-dialog__mask"></div>',
            '<div class="wg-basic-half-screen-dialog__wraper">',
            '<div class="wg-basic-half-screen-dialog__content">',
            '</div>',
            '<div class="wg-basic-half-screen-dialog__bottom"></div>',
            '<div class="wg-basic-half-screen-dialog__extra"></div>',
            '</div>',
        ]

        dom.innerHTML = div.join('')
        document.body.appendChild(dom)
    }
}

HalfScreenDialog.prototype.insertBottom = function (bottomHtml) {
    var dom = document.querySelector('.wg-basic-half-screen-dialog__extra');

    dom.innerHTML += bottomHtml;
}

HalfScreenDialog.prototype.insertData = function (html) {
    var dom = document.querySelector('.wg-basic-half-screen-dialog__content');

    if (dom) {
        if (typeof html === 'string') {
            dom.innerHTML = html;
        } else if (Array.isArray(html) && html.length > 0) {
            let contentHtml = '';

            html.forEach(item => {
                contentHtml += item.html;
            })

            dom.innerHTML += contentHtml;
            // 依次绑定事件
            this.bindItemEvent(html);
        }
    }
}

HalfScreenDialog.prototype.bindItemEvent = function (html) {
    if (Array.isArray(html) && html.length > 0) {
        html.forEach(item => {
            
            let eventType = item.eventType || 'click';
            if (item.target && item.callback) {
                let dom = document.querySelector(item.target);
                dom.addEventListener(eventType, item.callback);
            }
        })
    }
}

HalfScreenDialog.prototype.insertButton = function (buttons) {
    var dom = document.querySelector('.wg-basic-half-screen-dialog__bottom'),
        isCustomButtons = Array.isArray(buttons);

    var html = [];

    if (isCustomButtons) {
        let buttonHtml = '';
        for (var i = 0; i < buttons.length; i++) {
            var buttonLabel = buttons[i].label || '',
                buttonType = buttons[i].type,
                buttonClassSuffix = 'default',
                buttonClass = 'wg-basic-half-screen-dialog__button-';

            if (buttonType && buttonType !== 'default') {
                buttonClassSuffix = buttonType;
            }
            buttonClass += buttonClassSuffix;

            if (buttons.length === 1) {
                buttonClass += ' wg-basic-half-screen-dialog__button-single'
            }

            buttonHtml = '<div class="wg-basic-half-screen-dialog__button ' + buttonClass + ' wg-basic-half-screen-dialog__button_' + i + '">' + buttonLabel + '</div>';
            html.push(buttonHtml);
        }
    } else {
        html = [
            '<div class="wg-basic-half-screen-dialog__button wg-basic-half-screen-dialog__button-left">取消</div>',
            '<div class="wg-basic-half-screen-dialog__button wg-basic-half-screen-dialog__button-primary">确定</div>',
        ]
    }

    dom.innerHTML += html.join('')

    if (isCustomButtons) {
        setTimeout(() => {
            for (var j = 0; j < buttons.length; j++) {
                let index = j;
                // 绑定按钮回调
                var buttonClass = '.wg-basic-half-screen-dialog__button_' + index;
                var buttonDom = document.querySelector(buttonClass);
                buttonDom && buttonDom.addEventListener('click', () => {
                    if(!this.retainDialog){
                        this.closeEvent();
                    }
                    buttons[index].callback();
                }
                )
            }
        }, 0);
    } else {
        this.buttonDom && this.bottomDom.addEventListener('click', () => {
            this.closeEvent()
        });
    }
}

HalfScreenDialog.prototype.bindEvent = function (buttons) {
    var self = this;
    let isCustomButtons = Array.isArray(buttons);

    this.maskDom.addEventListener('click', function () {
        if (!self.retainDialog) {
            self.closeEvent();
          }
          if (isCustomButtons) {
            const cancelButton = buttons.find(v => v.label === '取消');
            if (cancelButton?.callback) {
              cancelButton.callback();
            }
          }
        
    })
}

HalfScreenDialog.prototype.closeEvent = function () {
    var self = this

    self.panelDom.style.bottom = '-100%'
    setTimeout(function () {
        self.maskDom.style.opacity = 0
        wxBridge && wxBridge.invoke("setGameTab", {isShowTab: 1})
    }, 200)
    setTimeout(function () {
        self.dialogDom.style.bottom = '-100%'

        self.dialogDom.parentNode.removeChild(self.dialogDom)

    }, 350)

    // this.cancelCbk()
}

HalfScreenDialog.prototype.update = function (html = '', retainDialog = false) {
    this.retainDialog = retainDialog;
    var dom = document.querySelector('.wg-basic-half-screen-dialog__content');
    if(dom){
        dom.innerHTML = ""
        if (typeof html === 'string') {
            dom.innerHTML = html;
        } else if (Array.isArray(html) && html.length > 0) {
            let contentHtml = '';

            html.forEach(item => {
                contentHtml += item.html;
            })

            dom.innerHTML += contentHtml;
            // 依次绑定事件
            this.bindItemEvent(html);
        }
    }

    // this.cancelCbk()
}

export default HalfScreenDialog;